/* import __COLOCATED_TEMPLATE__ from './bulk-clear-schedule-agent-modal.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  onClose: () => void;
  onConfirm: () => void;
  isBulkActionRunning: boolean;
}

const BulkClearScheduleAgentModal = templateOnlyComponent<Args>();
export default BulkClearScheduleAgentModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::BulkActions::BulkClearScheduleAgentModal': typeof BulkClearScheduleAgentModal;
    'knowledge-hub/filterable-list/bulk-actions/bulk-clear-schedule-agent-modal': typeof BulkClearScheduleAgentModal;
  }
}
